/* import __COLOCATED_TEMPLATE__ from './uninstall-slack-integration-button.hbs'; */
import Component from '@glimmer/component';

export default class UninstallSlackIntegrationButton extends Component {}
